/**
 * Account views: handle login/logout/...
 * Path: `@/views/account`
 * - User settings views: handle current user settings
 * - Company settings views: handle company settings
 */

import multiguard from "vue-router-multiguard"
import { logout, requireAuth, requireCompany, requireCompanyOwner } from "@/utils/middleware"

const CompanyTeam = () => import("@/views/account/company/CompanyTeam.vue")
const Department = () => import("@/views/account/department/Department.vue")
const CompanyTeamInvitation = () => import("@/views/account/company/CompanyTeamInvitation.vue")
const Profile = () => import("@/views/account/user/Profile.vue")
const ResetPassword = () => import("@/views/account/ResetPassword.vue")
const SignIn = () => import("@/views/account/SignIn.vue")
const SignUp = () => import("@/views/account/SignUp.vue")
const Mfa = () => import("@/views/account/Mfa.vue")
const SignupActivation = () => import("@/views/account/SignupActivation.vue")

export default [
  {
    path: "/account",
    name: "Account",
    redirect: { name: "Profile" }
  },
  {
    path: "/account/profile",
    name: "Profile",
    component: Profile,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/account/department",
    name: "CompanyDepartment",
    component: Department,
    beforeEnter: multiguard([requireCompany]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/account/team",
    name: "CompanyMembers",
    component: CompanyTeam,
    beforeEnter: multiguard([requireCompany]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/company/team/invitation",
    name: "CompanyInvitation",
    component: CompanyTeamInvitation,
    beforeEnter: multiguard([requireCompany, requireCompanyOwner]),
    meta: {
      layout: "default"
    },
    props: {
      isForProject: false
    }
  },
  {
    path: "/account/password-reset/confirm/:uid/:key",
    component: ResetPassword,
    name: "Reset Password Confirm",
    meta: {
      layout: "unauthenticated"
    }
  },
  {
    path: "/signin",
    name: "SignIn",
    component: SignIn,
    meta: {
      layout: "unauthenticated"
    }
  },
  {
    path: "/signin/:uid/:key",
    component: ResetPassword,
    name: "Reset Password",
    meta: {
      layout: "unauthenticated"
    }
  },
  {
    path: "/signup",
    component: SignUp,
    name: "Sign up",
    meta: {
      layout: "unauthenticated"
    }
  },
  {
    path: "/verification-otp",
    component: Mfa,
    name: "Verification",
    meta: {
      layout: "unauthenticated"
    }
  },
  {
    path: "/signup/activation/:key",
    component: SignupActivation,
    name: "Sign up Activation"
  },
  {
    path: "/signup/invite/:key",
    component: SignUp,
    name: "Sign up invitation",
    meta: {
      layout: "unauthenticated"
    }
  },
  {
    path: "/logout",
    name: "Logout",
    beforeEnter: multiguard([logout])
  }
]
